<template>
  <div class="beauty-makeup">
    <s-r-m-header ref="header" />
    <carousel-container ref="carouselContainer" :carouselInfo="carouselInfo" dark />
    <PointOfPain 
      :listData="listData" 
      title="日化美妆行业PLM的行业痛点以及解决方案"
    />
    <PointOfPain 
      :isTriangle="true"
      :isThree="true"
      :listData="listData2" 
      triangleContent="解决方案"
    />
    <!-- <PlatformOverview></PlatformOverview> -->
    <CoreStrengths
      title="日化美妆行业PLM的核心功能"
      description="覆盖需求、立项、物料、配方、工艺、检测、安评等主要功能，实现日化美妆行业的一体化生命周期管理"
      :otherTopList="coreStrengthList"
    ></CoreStrengths>
    <p-l-m-a-i-application theme="blue" />
    <!-- <product-features
      title="璞华易研PLM（流程行业）的主要功能"
      description="为化工材料、食品饮料、日化等行业客户提供核心技术管理、资源池管理、效率工具、五大基石、数据建模"
      :tabList="tabList"
    ></product-features> -->
    <PointOfPain 
      :listData="technicalBrillianceData" 
      :isThree="true"
      title="日化美妆行业PLM的主要特点"
    />
    <success-cases
      ref="successCases"
      title="璞华易研PLM的典型案例"
      description="多行业领域的实施经验提供更加垂直化的解决方案，助力企业提升研发效率"
      :caseList="caseList"
    />
    <KeyAdvantages :banner-height="bannerHeight2"></KeyAdvantages>
    <!-- <Scheme :schemeList="schemeList"></Scheme>  -->
    <ChooseUs :nameVals="['ChemicalIndustry', 'Food', 'Pharmaceutical', 'WearMakeup']" :scrollNum="3"></ChooseUs>
    <custom-form ref="customForm" />
    <footer-box />
  </div>
</template>

<script>
import CoreStrengths from "@/components/CoreStrengths"
import SRMHeader from "@/components/SRMHeader/index";
import CarouselContainer from "@/components/CarouselContainer/single"
import PointOfPain from "@/components/PointOfPain/index"
import PlatformOverview from "@/components/PlatformOverview"
import ProductFeatures from "@/components/ProductFeatures"
import SuccessCases from "@/components/SuccessCases"
import KeyAdvantages from "@/components/KeyAdvantages"
import PLMAIApplication from "@/components/PLMAIApplication"
import Scheme from "@/components/Scheme"
import ChooseUs from "@/components/ChooseUs"
import CustomForm from "@/components/Form"
import FooterBox from "@/components/FooterBox"
import { baiduConsult } from "./common.js";

import hgs1 from '@/assets/images/zym-rh.png'
import gn1 from '@/assets/images/gn1-1.png'
import gn2 from '@/assets/images/gn1-2.png'
import gn3 from '@/assets/images/gn1-3.png'
import gn4 from '@/assets/images/gn1-4.png'
import gn5 from '@/assets/images/gn1-5.png'

import al1 from '@/assets/images/al1-1.png'
import al2 from '@/assets/images/al1-2.png'
import al3 from '@/assets/images/al1-3.png'

import al11 from '@/assets/images/al1-11.jpg'
import al12 from '@/assets/images/al1-12.jpg'
import al13 from '@/assets/images/al1-13.jpg'
import al14 from '@/assets/images/al1-14.jpg'



import hg1 from '@/assets/images/hg1.png'
import hg2 from '@/assets/images/hg2.png'
import hg3 from '@/assets/images/hg3.png'
import hg4 from '@/assets/images/hg4.png'
import hg5 from '@/assets/images/hg5.png'

import dz1 from '@/assets/images/dz1.png'
import dz2 from '@/assets/images/dz2.png'
import dz3 from '@/assets/images/dz3.png'
import dz4 from '@/assets/images/dz4.png'
import dz5 from '@/assets/images/dz5.png'
import dz6 from '@/assets/images/dz6.png'

import hx01 from '@/assets/images/hx-1.png'
import hx02 from '@/assets/images/hx-2.png'
import hx03 from '@/assets/images/hx-3.png'
import hx04 from '@/assets/images/hx-4.png'
import hx05 from '@/assets/images/hx-5.png'
import hx06 from '@/assets/images/hx-6.png'
import hx07 from '@/assets/images/hx-7.png'

import hx1 from '@/assets/images/hx1.png'
import hx2 from '@/assets/images/hx2.png'
import hx3 from '@/assets/images/hx3.png'
import hx4 from '@/assets/images/hx4.png'
import hx5 from '@/assets/images/hx5.png'
import hx6 from '@/assets/images/hx6.png'
import hx7 from '@/assets/images/hx7.png'



export default {
  components: {
    SRMHeader,
    CarouselContainer,
    PointOfPain,
    CustomForm,
    FooterBox,
    ProductFeatures,
    Scheme,
    PlatformOverview,
    ChooseUs,
    SuccessCases,
    KeyAdvantages,
    PLMAIApplication,
    CoreStrengths
  },
  metaInfo() {
    return {
      title: '日化PLM软件_美妆PLM系统_日化美妆行业PLM平台解决方案_国产PLM供应商_PLM厂家_PLM产品_PLM排名',
      meta: [
        {
          name: 'keywords',
          content: '日化PLM,美妆PLM,护肤品PLM,,香精PLM,香氛PLM,美妆研发管理,日化产品研发管理,化妆品配方管理,化妆品合规管理'
        },
        {
          name: 'description',
          content: '璞华易研PLM 系统，提供日化行业PLM、美妆个护PLM、护肤品PLM、消费品PLM、香精香氛PLM等解决方案，支持配方精细化管理，合规管理，助力企业实现个性化产品研发与高效生产，在美妆日化市场脱颖而出。'
        }
      ]
    }
  },
  data() {
    return {
      ratio: null,
      bannerHeight2: null,
      carouselInfo: {
        title: '日化美妆行业PLM',
        description: '日化、个护、彩妆、护肤品、化妆品、护理品...... <br/> 基于AI智能合规引擎与全流程数字化技术，覆盖需求到备案上市的全生命周期管理',
        bg: hgs1
      },
      technicalBrillianceData: [
        {
          num: '01',
          title: 'AI深度赋能',
          contentList: [
            {
              content: '配方推荐引擎：基于2000+历史配方数据训练，通过AI算法整合历史配方数据、成分功效数据库及消费者偏好分析，生成创新配方建议。推荐准确率超85%。'
            },
            {
              content: '自动化合规引擎：AI实时抓取170+国家法规更新（如欧盟、中国新条例），自动生成合规标签与安全数据表（SDS），某企业法规审核时间从数周缩短至24小时。'
            }
          ]
        },
        {
          num: '02',
          title: '全链路数字化',
          contentList: [
            {
              content: '云端协同：支持多地研发团队实时编辑配方（冲突自动合并），版本管理精度达秒级'
            },
            {
              content: '设备互联：对接电子天平/IoT设备，自动采集数据并生成试制报告（减少80%人工录入）'
            }
          ]
        },
        {
          num: '03',
          title: '合规穿透管理',
          contentList: [
            {
              content: '全球法规地图：动态标注各国限值差异（如欧盟铅限值10ppm vs 中国20ppm），自动生成合规差异报告'
            },
            {
              content: '备案材料工厂：支持多国语言自动翻译（中/英/日/韩），格式适配率100%（如欧盟CPNP系统）'
            }
          ]
        }
      ],
      coreStrengthList: [
        {
          val: '01',
          title: '需求管理',
          contentImg: hx01,
          description: '市场需求模板化（含功效/成分/包装要求）、AI需求价值评估（ROI预测）'
        },
        {
          val: '04',
          title: '立项与项目管控',
          contentImg: hx02,
          description: '多维度项目模板库（新原料开发/方法开发）、资源负荷分析（设备/物料/人员）'
        },
        {
          val: '05',
          title: '物料管理',
          contentImg: hx03,
          description: '智能物料库（支持CAS/INCI双编码）、物质成分、研发物料库存管理'
        },
        {
          val: '06',
          title: '配方设计',
          contentImg: hx04,
          description: '多配方协同设计（支持Excel/云端协同）、AI成分推荐（基于功效+法规+成本）、合规预计、配伍提醒'
        },
        {
          val: '07',
          title: '工艺管理',
          contentImg: hx05,
          description: '支持建立行业通用工艺路线模板（如膏霜乳化、香水调香等）、BOM自动下发（支持版本锁定）'
        },
        {
          val: '09',
          title: '检测管理',
          contentImg: hx06,
          description: '检测方案智能生成（如微生物限度检测项目自动配置）、数据看板（稳定性趋势分析）'
        },
        {
          val: '10',
          title: '安评备案',
          contentImg: hx07,
          description: '备案文档智能组装（自动匹配区域模板）、合规性自检（法规条款、包装文案一键比对）'
        }
      ],
      tabList: [
        {
          name: 'first',
          label: '技术核心管理',
          title: '1. 技术核心管理',
          description: '围绕需求与实验，精细化管理资源池，实现高效的后勤保障、资源调度与资源复用',
          effectDrawing: gn1,
          contentList: [
            {
              title1: '配方管理',
              content1: 'BOM结构化、正反结构查询、替代料管理、自动计算、研发/生产多场景视图、版本比较'
            },
            {
              title1: '工艺管理',
              content1: '文件模板化、参数指标结构化、图文表并茂式呈现、单/多工序场景差异化维护、装备设备管理'
            },
            {
              
              title1: '实验过程管理',
              content1: '配方工艺多途径维护、样品物性数据可视化对比、自动出具实验与检验报告、权限多维度细分'
            },
            {
              title1: '材料成本分析',
              content1: '配方材料成本自动计算、物料价格走势图表化比对'
            },
            {
              title1: '配方成本预测',
              content1: '物料价格影响利润预测、配方成本虚拟运算、浮动情况可视化比较'
            }
          ]
        },
        {
          name: 'second',
          label: '资源池管理',
          title: '2. 资源池管理',
          description: '以配方、工艺、成本为核心，整合产品全生命周期数据，涓汇、沉淀经验库',
          effectDrawing: gn2,
          contentList: [
            {
              title1: '配方高级检索',
              content1: 'B支持以物性要求、原料占比等多条件维度检索产品配方资源池，获取适配的历史经验参考'
            },
            {
              title1: '实验设备看板',
              content1: '支持设备资产管理，动态维护实验设备状态，预约协调档期，利用率、故障率可视化统计'
            },
            {
              title1: '实验人员看板',
              content1: '支持看板动态维护实验人员状态，预约、协调其档期，支持工时统计、比较'
            },
            {
              title1: '实验物料库存',
              content1: '支持实验物料出入库管理，自动扣减实验打样所耗物料，提供呆滞料数量、价值可视化统计'
            },
            {
              title1: '模具耗材管理',
              content1: '提供实验模具、耗材等出入库管理台账，自动分配编号批号，助力资源库存预警，及时补货备货'
            }
          ]
        },
        {
          name: 'third',
          label: '效率工具',
          title: '3. 效率工具',
          description: '基于提质增效目标，配套灵活的个性化效率工具，助力研发活动响应效率',
          effectDrawing: gn3,
          contentList: [
            {
              title1: '系统模板',
              content1: '内置多套材料化工行业文件模板方案，支持用户个性化自定义、扩展'
            },
            {
              title1: '代办授权',
              content1: '支持业务流程临时委托代办授权，支持各对象读写用临时授权，配套快速审核等在线监督机制'
            },
            {
              title1: '流程效率分析',
              content1: '提供业务流程效率分析，支持以流程类型、流转节点、操作者等多维度分析业务流转效率'
            },
            {
              title1: '在线可视化',
              content1: '采用最新的BS架构，支持40多种主流的文件格式在线预览，所见即所得；配套多场景自动图表'
            },
            {
              title1: '第三方集成',
              content1: '自带主流的集成接口，轻松实现与ERP、MES、办公软件等的集成协同，支持数据导出'
            }
          ]
        },
        {
          name: 'four',
          label: '五大基石',
          title: '4. 五大基石',
          description: '内置材料化工通用的业务对象管理，为产品履历、数据分析、知识传承奠定坚实的基础',
          effectDrawing: gn4,
          contentList: [
            {
              title1: '物料',
              content1: '编码规则自定义、型号/牌号关联、属性配置、生命周期管理、版本管理、分类分组定义、自动转码等'
            },
            {
              title1: '文档',
              content1: '内置行业常用文档模型（如标准法规、检验规范、检测项目等），支持自定义扩展、分类分组管理等'
            },
            {
              title1: '流程',
              content1: '内置行业常用ECR-ECO变更方案，提供行业领先的用户可编程引擎，支持拖曳式自定义配置'
            },
            {
              title1: '报表',
              content1: '预置多场景自动图表（如对比图、统计图、走势图等）与分析表单，支持导出与打印'
            },
            {
              title1: '项目',
              content1: '项目计划+项目进度+项目交付+项目报表，帮助企业实现项目集管理，规范项目数据，缩短研发周期'
            }
          ]
        },
        {
          name: 'five',
          label: '数据建模',
          title: '5. 数据建模',
          description: '通过数据建模，支持客户个性化需求的高效灵活扩展，适应企业业务的发展衍变',
          effectDrawing: gn5,
          contentList: [
            {
              title1: '模型管理',
              content1: '支持数据、流程、字段级别的数据建模和精细化的权限控制'
            },
            {
              title1: '配置扩展',
              content1: '支持根据客户的个性化需求配置基础设置、对象分类、对象属性、工作流程、权限等'
            },
            {
              title1: '编码版本',
              content1: '支持适配企业体系化管理的各种编码、版本规则定义，支持内部文件与外来文件的差异化管理'
            },
            {
              title1: '用户管理',
              content1: '组织架构管理、用户信息管理、隶属关系管理、状态管理、行为日志、角色关联列表'
            },
            {
              title1: '角色权限',
              content1: '角色配置、用户关联、字段级数据权限、菜单权限、页签权限、按钮权限、读写权限'
            }
          ]
        }
      ],
      caseList: [
        {
          label: '丸美生物PLM数字化转型',
          link: 'https://www.plmcenter.cn/cases/case-marubi/',
          describe: '研发数据分散于多个系统，缺乏统一平台导致信息孤岛严重，协同效率低下。研发过程透明度不足，难以实现全生命周期追溯，存在合规性风险与质量管控盲区。',
          advantage: ['研发效率显著提升', '数据管理统一规范'],
          img: al11
        },
        {
          label: '云南白药集团AI驱动研发管理平台',
          link: 'https://www.plmcenter.cn/cases/case-yunnanbaiyao/',
          describe: '传统中华老字号企业面临数字化转型挑战，研发过程缺乏智能化支持，产品创新周期长，市场响应速度有待提升。',
          advantage: ['ABILITY提升', '研发成本有效降低'],
          img: al12
        },
        {
          label: '麦克韦尔介质合规及研发导产系统',
          link: 'https://www.plmcenter.cn/cases/case-mcwell/',
          describe: '随着G4研究院业务增多、客户合作加深，法规变动较快，市场端更关注介质合规与品质。线下介质配方研发与导产方式严重影响业务效率、质量合规及成本，跟不上市场环境变化。',
          advantage: ['研发效率显著提升', '合规管控全面加强'],
          img: al13
        },
        {
          label: '容大生物PLM数字化转型',
          link: 'https://www.plmcenter.cn/cases/case-rongda/',
          describe: '配方版本混乱、研发数据分散、跨部门协同效率低、合规要求提升及产品迭代加速，需解决数据孤岛与成本控制问题。',
          advantage: ['研发效率提升', '数据管理优化'],
          img: al14
        }
      ],
      schemeList: [
        {
          val: '01',
          label: '化工材料行业',
          title: '应用场景',
          descriptions: [
            '目前，世界范围内化工产业发展迅速，新产品不断推出。同时，市场竞争加剧，产品同质化倾向比较明显，对数字化转型的要求也越来越高。需要覆盖产品全生命周期的闭环研发体系、跨部门跨地域的协同研发体系、基于数据收集和分析的数据建模数据管理体系、以及与第三方系统进行高效对接的系统集成机制。', 
            '璞华易研PLM基于10多年的PLM咨询实施经验，因应化工行业的发展需求，为化工行业提供最佳实践。',
            '我们在化工行业拥有丰富的咨询和实施经验，为客户在激烈的市场竞争中提升产品竞争力。'
          ],
          mainDesc: '化工材料行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        },
        {
          val: '02',
          label: '电子高科技',
          title: '应用场景',
          descriptions: [
            '最近几年，电子高科技行业呈现出激烈的竞争局面，产品上市速度快，具有创新性的产品也不断推出。要在电子产品领域赢得竞争，必须面向消费者、关注设计、富有创新、快速推向市场，产品的全生命周期管理显得越来越重要。',
            '为了因应这一时代潮流，璞华易研PLM关注数据建模和数据管理，通过项目管理和变更管理，推动部门之间、地域之间进行无缝协作，强化与第三方系统的对接，让产品生命周期管理变得快捷、高效。'
          ],
          mainDesc: '电子高科技行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: dz1, label: '数据管理' },
            { icon: dz2, label: '数据建模' },
            { icon: dz3, label: '变更管理' },
            { icon: dz4, label: '项目管理' },
            { icon: dz5, label: '在线可视化' },
            { icon: dz6, label: '第三方接入' }
          ]
        },
        {
          val: '03',
          label: '芯片半导体',
          title: '应用场景',
          descriptions: [
            '设计成本上涨、产品日益复杂、创新步伐加快，这些均给半导体企业造成很大的压力。该行业研发设计挑战艰巨、生命周期日益缩短。璞华易研PLM，帮助芯片半导体客户极大的改善了新产品开发和生命周期的流程管理。'
          ],
          mainDesc: '芯片半导体行业的PLM应用主要包括以下主要内容',
          mianFeatures: [
            { icon: dz1, label: '数据管理' },
            { icon: dz2, label: '数据建模' },
            { icon: dz3, label: '变更管理' },
            { icon: dz4, label: '项目管理' },
            { icon: dz5, label: '在线可视化' },
            { icon: dz6, label: '第三方接入' }
          ]
        },
        {
          val: '04',
          label: '医疗器械',
          title: '应用场景',
          descriptions: [
            '医疗器械行业对产品安全性和有效性要求特别高，因此对产品的设计、生产过程要求尤其严格。',
            '医疗器械制造商的竞争也日趋激烈，使得企业在产品管理方面迫切需要通过一种更为系统化、更为全面、更高效的产品生命周期管理方法以及对应的管理平台来迎接这些新挑战。',
          ],
          mainDesc: '医疗器械行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        },
        {
          val: '05',
          label: '工业制造',
          title: '应用场景',
          descriptions: [
            '工业设备等制造业的分工合作越来越细，而部门的相对独立以及客户化定制要求，导致产品研制周期长且协同较少，研发部门到生产部门往往只有纸质文件传递，这对企业的设计生产方式、管理模式提出了严峻挑战。',
            '企业实施PLM项目管理可以使产品开发管理更加精细化，通过细化项目管理颗粒度，打破研发过程中部门之间的壁垒，从而实现研发、工艺、制造计划的协同分工与统筹安排。',
            '璞华易研PLM能帮助企业在管理和工作效率方面得到极大提升，实现上游技术部门和下游生产制造部门之间信息及时传递和共享。'
          ],
          mainDesc: '工业制造行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        }
      ],
      listData: [
        {
          num: '01',
          title: '技术传承断层与研发低效',
          contentList: [
            {
              content: '配方、工艺数据分散存储（Excel/纸质文件），复用率不足30%，同类产品重复开发成本增加40%以上'
            },
            {
              content: '研发经验依赖人工传递，新员工培训周期长达6-12个月，试制数据离散化导致追溯率不足60%'
            }
          ]
        },
        {
          num: '02',
          title: '合规与备案风险高企',
          contentList: [
            {
              content: '安评报告人工编制效率低（单份耗时3-5天），法规更新滞后（如欧盟EC、中国《化妆品监督管理条例》）导致合规错误率超15%'
            },
            {
              content: '化妆品备案因格式差异平均延误2-4周，文档版本管理混乱导致审核驳回率超20%'
            }
          ]
        },
        {
          num: '03',
          title: '研产协同与成本控制难题',
          contentList: [
            {
              content: '技术文件机器可读性差，配方成本人工计算耗时占研发周期超25%'
            },
            {
              content: '设备与物料调度依赖人工协调，资源冲突导致打样周期延长超30%'
            }
          ]
        },
        {
          num: '04',
          title: '数据安全与质量追溯薄弱',
          contentList: [
            {
              content: '技术数据权限管控粗放，部分企业泄密风险年损失超百万级'
            },
            {
              content: '实验记录缺失率超20%，质量追溯依赖人工复盘，问题定位平均耗时超48小时'
            }
          ]
        }
      ],
      listData2: [
        {
          num: '05',
          title: 'AI智能合规引擎',
          contentList: [
            {
              content: '自动化法规校验：内置全球200+法规库（如《化妆品安全技术规范》），实时同步更新，合规错误率降低90%'
            },
            {
              content: '智能安评报告生成：基于NLP技术解析实验数据，自动生成检测报告，效率提升70%'
            }
          ]
        },
        {
          num: '06',
          title: '全流程数字化管理平台',
          contentList: [
            {
              content: '需求-立项-交付闭环：支持市场部需求快速导入（模板化），AI自动匹配相似项目模板，立项周期缩短50%'
            },
            {
              content: '研产协同中台：打通配方设计（支持多维度参数模拟）、工艺参数协同、配方自动下发，试产周期压缩30%'
            }
          ]
        },
        {
          num: '07',
          title: '研发生态构建',
          contentList: [
            {
              content: '知识库：结构化沉淀10万+实验数据，支持配方AI智能推荐（如“防晒剂+pH值6.5”场景），复用率提升70%'
            },
            {
              content: '试验平台：AI优化检测方案（如稳定性测试关键指标自动筛选），检测报告自动生成，数据异常实时预警'
            }
          ]
        }
      ]
    }
  },
  mounted() {
    this.setSize();
    window.addEventListener("resize", () => {
      this.setSize();
    }, false );

    baiduConsult();
  },
  methods: {
    setSize() {
      this.bannerHeight2 = document.body.clientWidth / (1920 / 450)
      if (document.body.clientWidth < 768) this.bannerHeight2 = 320
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/mixins.scss";

.beauty-makeup {
  ::v-deep .srm-header {
    padding-right: 8rem;
  }
  ::v-deep .productfeature .tab-container .el-tabs .el-tabs__header .el-tabs__nav .el-tabs__item {
    width: 28rem;
  }
  ::v-deep .productfeature {
    .content-left {
      padding: 0;
      left: 26rem;
      width: 54rem;
    }
    .content-right {
      width: 88.2rem;
      height: 51rem;
      top: 12.7rem;
      right: 17.1rem;
    }
  }
  ::v-deep .point-of-pain {
    .list-item {
      padding-top: 4rem;
      .cl-list {
        margin-top: 2.1rem;
      }
    }
    .cl-l-i-content {
      line-height: 3rem !important;
    }
  }
  ::v-deep .core-strengths {
    .list-item {
      padding: 2rem 2.9rem !important;
    }
  }

  @include mobile-page-overrides;
}
</style>
